import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { CircularProgress } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import useCommonApi from "../../api/useCommonApi";

export interface IAutocompleteSolicitud {
    id: number | string
    colonia: any
    colonium?: any
    calle: string
    codigoPostal: string
    nombreClienteDistribuidor:string
    parentId: number | string
}

interface IAutocompleteProps { 
    name: string
    source: string
    label: string
    placeholder?: string
    value: IAutocompleteSolicitud | null
    defaultValue?: IAutocompleteSolicitud | null
    filter?: any
    variant?:any
    onChange: <T>(event, optionSelected: T) => void
}

const AutocompleteControlSolicitud = ({
    value,
    source,
    label,
    onChange,
    placeholder,
    filter,
    variant
}: IAutocompleteProps) => {

  

    const [searchText, setSearchText] = useState('');
    const [options, setOptions] = React.useState<IAutocompleteSolicitud[]>([]);
    const [loading, setLoading] = useState(false);

    const apiSource = useCommonApi();

    useEffect(() => {

        let text = ''
        if (value?.parentId) {
            text = value?.parentId.toString()
        } else if (value?.codigoPostal) {
            text = value?.codigoPostal.toString()
        }

        setSearchText(text)
    }, [value]);

    useEffect(() => {
        const timer = setTimeout(triggerChange, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, [searchText]);

    const triggerChange = () => {

        if (searchText) {
            setLoading(true);
            (async () => {
                const data = { Texto: searchText, ...filter };
                const result = await apiSource.obtenerAsync<IAutocompleteSolicitud[]>(source, data);

                setOptions(result);
                setLoading(false);
            })();
        } else{
            setOptions([]);
        }
    };

    const textChange = (event) => {
        setSearchText(event.target.value)
    };

    const handleChange = (event, optionSelected) => {
        if (!optionSelected) setOptions([]);
        if (event != null) {
            onChange(event, optionSelected)
        }

    };

    return (
        <>
            <Autocomplete
                options={options}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={option => option.codigoPostal?.toString()}
                filterOptions={(options) => options}
               
                renderOption={(option) => (
                    <>
                        <Box display="flex" flexDirection="column" fontSize={14}>
                        <Box fontWeight="fontWeightBold">
                                {option.nombreClienteDistribuidor}
                            </Box>
                            <Box fontWeight="fontWeightMedium">
                                {option.calle}, {option.colonium?.pais.nombre}
                            </Box>
                            <Box fontWeight="fontWeightLight" fontSize={10}>
                                {option.codigoPostal}
                            </Box>
                        </Box>
                    </>
                )}
                onChange={handleChange}
                value={value}
               
                loading={loading}
                renderInput={params => (
                    <TextField
                        {...params}
                        onChange={textChange}
                       
                        variant={variant == null ? "filled" :variant}
                        label={label}
                        placeholder={placeholder || ""}
                        fullWidth
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
            />
        </>
    );
};

export default AutocompleteControlSolicitud;
